/*************************************************/
/* Partials                                      */
/*************************************************/
import { video } from "./partials/video.js";
import { modal } from "./partials/modal.js";
import { cookies } from "./partials/cookies.js";

/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {
    const body = document.querySelector('body'),
    bodyLoadingClass = 'is-loading';

    modal(body, bodyLoadingClass);
    video();
    cookies();
});
